import axios from 'axios';
import Constants from '../constants';
import { IQuestionChange, IQuestionChangeActionVm } from '../models';

export const questionChangesUrl = (surveyId: number, includeChanges?: boolean) => {
	let url = Constants.API_SURVEY_QUESTION_CHANGES_URL.replace('{surveyId}', surveyId.toString());
	if (includeChanges) {
		url += '?includeChanges=true';
	}
	return url;
};

export async function getQuestionChanges(
	surveyId: number,
	questionChangeActionVm: IQuestionChangeActionVm,
	includeChanges?: boolean,
): Promise<IQuestionChange[]> {
	const res = await axios.post(questionChangesUrl(surveyId, includeChanges), questionChangeActionVm, { headers: Constants.noCacheHeader });
	return res.data;
}
